<template>
  <section class="batch-modify cross-attribute" :class="{ 'has-submit-error': submissionError }">
    <header class="batch-head">
      <div class="crumb">
        <button class="plain" @click="leave">‹ 返回</button><span>商品工作台　›　批量修改　›　跨类目属性</span>
      </div>
      <h1>批量修改跨类目属性</h1>
      <nav>
        <button
          v-for="tab in tabs"
          :key="tab.value"
          :class="{ active: mode === tab.value }"
          :disabled="confirming"
          @click="mode = tab.value">
          {{ tab.label }}
        </button>
      </nav>
    </header>
    <main>
      <section class="panel">
        <div v-if="mode === 'products'" class="picked">
          <button :disabled="confirming" @click="openSelector">选择商品</button>
          <span
            >已选择 <b>{{ selected.length }}</b> 个商品</span
          >
        </div>
        <div v-if="mode === 'product_ids'" class="ids">
          <label>抖店商品 ID</label>
          <el-input
            v-model="idsText"
            type="textarea"
            :rows="3"
            :disabled="confirming"
            placeholder="多个 ID 用逗号、空格或换行分隔，支持 Excel 粘贴" />
        </div>
        <div v-if="mode === 'range'" class="filters">
          <label v-if="mode === 'range'" class="field"
            ><span>商品分类（可选）</span
            ><doudian-category-cascader v-model="filters.category_id" :categories="categories" :disabled="confirming"
          /></label>
          <label v-for="field in shownFields" :key="field.key" class="field">
            <span>{{ field.label }}<small v-if="field.runtime">（需核验数据）</small></span>
            <el-date-picker
              v-if="field.date"
              v-model="filters[field.key]"
              :disabled="confirming"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始时间"
              end-placeholder="结束时间" />
            <div v-else-if="field.matchKey" class="combined-control">
              <el-select v-model="filters[field.matchKey]" :disabled="confirming" :aria-label="field.label + '匹配方式'"
                ><el-option
                  v-for="option in field.matchOptions"
                  :key="option.value"
                  :value="option.value"
                  :label="option.label"
              /></el-select>
              <div v-if="field.range" class="range">
                <input
                  v-model="filters[field.key + '_min']"
                  :disabled="confirming"
                  :aria-label="field.label + '最小值'"
                  placeholder="最小值" /><span>~</span
                ><input
                  v-model="filters[field.key + '_max']"
                  :disabled="confirming"
                  :aria-label="field.label + '最大值'"
                  placeholder="最大值" />
              </div>
              <input
                v-else
                v-model="filters[field.key]"
                :disabled="confirming || filters[field.matchKey] === 'empty'"
                :aria-label="field.label"
                :placeholder="
                  filters[field.matchKey] === 'empty' ? '无需填写' : field.placeholder || '请输入' + field.label
                " />
            </div>
            <div v-else-if="field.range" class="range">
              <input
                v-model="filters[field.key + '_min']"
                :disabled="confirming"
                :aria-label="field.label + '最小值'"
                placeholder="最小值" /><span>~</span
              ><input
                v-model="filters[field.key + '_max']"
                :disabled="confirming"
                :aria-label="field.label + '最大值'"
                placeholder="最大值" />
            </div>
            <el-select v-else-if="field.options" v-model="filters[field.key]" :disabled="confirming" clearable
              ><el-option
                v-for="option in field.options"
                :key="String(option.value)"
                :value="option.value"
                :label="option.label"
            /></el-select>
            <input
              v-else
              v-model="filters[field.key]"
              :disabled="confirming"
              :aria-label="field.label"
              :placeholder="field.placeholder || '请输入条件'" />
          </label>
        </div>
        <footer v-if="mode === 'range'" class="filter-actions">
          <doudian-batch-shop-scope v-model="shops" :shops="shopOptions" :disabled="confirming" />
          <div class="filter-buttons">
            <button class="more-search" :disabled="confirming" @click="more = !more">
              {{ more ? '收起更多搜索 ▴' : '更多搜索 ▾' }}
            </button>
            <button :disabled="loading || confirming || fabricBusy" @click="loadPreview(1)">查询</button>
            <button class="plain" :disabled="confirming" @click="resetFilters">重置</button>
          </div>
        </footer>
        <p v-if="mode === 'range'" class="hint">
          不同条件同时满足才命中；一个 SKU 满足已设置的 SKU
          条件即可命中商品。条件筛选有些无法直接查询结果，通过数据命中来判断是否符合。
        </p>
      </section>
      <doudian-batch-common-options v-model="commonOptions" :disabled="confirming" />
      <section class="panel methods">
        <h3><i></i>修改内容</h3>
        <div class="method-body">
          <p class="hint">按属性名精确匹配，每件商品再按所属类目的实际类型校验。合法项修改，不符合规则的项保留原值。</p>
          <fieldset :disabled="confirming">
            <section v-for="group in groups" :key="group.kind" class="rule-group">
              <el-checkbox v-model="group.enabled" :disabled="confirming">{{ group.label }}</el-checkbox>
              <div
                v-for="(row, index) in group.rows"
                :key="row.key"
                class="cross-rule-row rule-options"
                :class="{ 'typed-rule': group.kind !== 'ordinary' }">
                <span v-if="group.kind !== 'ordinary'" class="rule-field-label">属性{{ index + 1 }}：</span>
                <el-input
                  v-model="row.name"
                  class="property-name"
                  :disabled="confirming"
                  :label="group.label + '名称' + (index + 1)"
                  :placeholder="group.kind === 'date' ? '例如：生产日期' : '属性名称（精确匹配）'"
                  maxlength="100" />
                <span v-if="group.kind !== 'ordinary'" class="rule-field-label value-label"
                  >属性值{{ index + 1 }}：</span
                >
                <template v-if="group.kind === 'ordinary'">
                  <el-select v-model="row.multiple" class="value-count" :disabled="confirming" aria-label="目标值数量"
                    ><el-option :value="false" label="单个值" /><el-option :value="true" label="多个值"
                  /></el-select>
                  <el-input
                    v-model="row.text"
                    class="property-value"
                    :disabled="confirming"
                    :label="'属性值' + (index + 1)"
                    :placeholder="row.multiple ? '多个值用中英文逗号分隔，仅多选属性适用' : '请输入目标属性值'" />
                </template>
                <div v-else-if="group.kind === 'date'" class="property-dates">
                  <el-date-picker
                    v-model="row.start"
                    class="date-bound"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="开始日期"
                    :disabled="confirming" />
                  <span class="date-separator">-</span>
                  <el-date-picker
                    v-model="row.end"
                    class="date-bound"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="结束日期"
                    :disabled="confirming" />
                </div>
                <div v-else class="measure-value">
                  <el-input
                    v-model="row.number"
                    class="measure-number"
                    :disabled="confirming"
                    label="属性数值"
                    placeholder="请输入数值" />
                  <el-popover
                    v-model="row.unitPickerVisible"
                    class="measure-unit"
                    placement="bottom-start"
                    trigger="click"
                    :width="140"
                    :disabled="confirming">
                    <div class="unit-options">
                      <section v-for="unitGroup in unitGroups" :key="unitGroup.label" class="unit-group">
                        <p>{{ unitGroup.label }}：</p>
                        <div class="unit-choices">
                          <button
                            v-for="unit in unitGroup.units"
                            :key="unit"
                            type="button"
                            class="unit-choice"
                            :disabled="confirming"
                            :class="{ selected: row.unit === unit }"
                            :aria-pressed="row.unit === unit"
                            @click="chooseUnit(row, unit)">
                            {{ unit }}
                          </button>
                        </div>
                      </section>
                    </div>
                    <el-input
                      slot="reference"
                      :value="row.unit"
                      class="unit-input"
                      readonly
                      :disabled="confirming"
                      label="属性单位"
                      placeholder="请选择单位"
                      ><i slot="suffix" class="el-icon-arrow-down"
                    /></el-input>
                  </el-popover>
                </div>
                <div class="row-actions">
                  <el-button
                    :disabled="confirming || ruleRowCount >= 20"
                    :aria-label="'增加' + group.label"
                    @click="addRow(group)"
                    >＋</el-button
                  ><el-button
                    :disabled="confirming || group.rows.length === 1"
                    :aria-label="'删除' + group.label + (index + 1)"
                    @click="group.rows.splice(index, 1)"
                    >－</el-button
                  >
                </div>
                <div v-if="group.kind === 'ordinary' && row.multiple && group.enabled" class="value-tags">
                  <el-tag v-for="value in splitValues(row.text)" :key="value" size="small">{{ value }}</el-tag>
                </div>
              </div>
              <p v-if="group.kind === 'measure'" class="hint">
                单位按商品所属类目的规则校验，不自动换算单位；复合模板保留原值。
              </p>
              <p v-if="group.kind === 'date'" class="hint">时间范围支持先配置，日期批量提交暂未开放。</p>
            </section>
            <el-checkbox v-model="skipExisting" :disabled="confirming">若原属性已设置，则不修改该属性</el-checkbox>
            <cross-fabric-rule-fields
              ref="fabric"
              v-model="fabricRule"
              :shops="shopOptions"
              :disabled="confirming"
              @validation="fabricError = $event"
              @busy="fabricBusy = $event" />
          </fieldset>
          <p class="hint">
            品牌、货号及其他图片必填属性请使用对应专用功能；面料请使用上方面料设置。多选会完整替换该属性，任一目标值不合法则整项不修改。
          </p>
        </div>
      </section>
      <section v-if="preview" class="panel preview cross-preview">
        <doudian-batch-preview-notice />
        <header class="preview-summary">
          <span
            ><strong>修改内容预览</strong>　候选 <b>{{ preview.total }}</b> 件，已排除 {{ excluded.length }} 件</span
          >
          <button class="plain" :disabled="confirming" @click="preview = null">收起预览</button>
        </header>
        <div class="preview-details">
          <span>
            本页可处理 {{ preview.page_counts.ready }} 件、跳过 {{ preview.page_counts.skipped }} 件、待核验
            {{ preview.page_counts.unknown }} 件。预览依据本地数据，实际修改以执行时核验为准。
          </span>
          <span v-if="!previewCurrent" class="warning">条件已变化，请重新查询预览。</span>
          <span v-if="preview.inactive_conditions && preview.inactive_conditions.length" class="warning">
            以下筛选暂不生效：{{ preview.inactive_conditions.join('、') }}
          </span>
        </div>
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>商品 / 店铺 / 类目</th>
                <th>逐项修改判断</th>
                <th>结果</th>
                <th>排除</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in preview.list" :key="item.id">
                <td>
                  <div class="preview-product">
                    <el-image
                      class="preview-product-image"
                      :src="productImage(item)"
                      :preview-src-list="productImage(item) ? [productImage(item)] : []"
                      fit="cover"
                      ><span slot="error">暂无图片</span></el-image
                    >
                    <div>
                      <small>{{ item.shop_name || item.shop_id }} · 类目 {{ item.category_id }}</small>
                      <p>{{ item.product_title }}</p>
                      <small>ID：{{ item.platform_product_id }}</small
                      ><strong>{{ productPrice(item) }}</strong>
                    </div>
                  </div>
                </td>
                <td>
                  <article v-for="result in item.rule_results || []" :key="result.rule_index" class="rule-result">
                    <b>{{ result.name }} · {{ typeLabel(result.type) }}</b>
                    <div>
                      {{ displayValue(result.old_value) }} →
                      {{
                        result.result === 'skipped' && result.target_value === null
                          ? '不修改'
                          : displayValue(result.target_value)
                      }}
                    </div>
                    <small>{{ result.message }}</small>
                    <div v-if="result.type === 'fabric'" class="fabric-preview-pictures">
                      <span>原图</span
                      ><el-image
                        v-for="url in fabricImages(result.old_value)"
                        :key="'old' + url"
                        :src="url"
                        :preview-src-list="fabricImages(result.old_value)"
                        fit="cover"
                        ><span slot="error">加载失败</span></el-image
                      >
                      <span>→ 目标图</span
                      ><el-image
                        v-for="url in fabricImages(result.target_value)"
                        :key="'new' + url"
                        :src="url"
                        :preview-src-list="fabricImages(result.target_value)"
                        fit="cover"
                        ><span slot="error">加载失败</span></el-image
                      >
                    </div>
                  </article>
                  <span v-if="!item.rule_results || !item.rule_results.length">{{
                    item.error_msg || '请设置规则后重新预览'
                  }}</span>
                </td>
                <td>{{ resultLabel(item.preview_result) }}<small v-if="item.common_only">仅处理共用选项</small></td>
                <td>
                  <el-checkbox
                    :value="excluded.includes(item.id)"
                    :disabled="confirming"
                    :aria-label="'排除商品' + item.platform_product_id"
                    @change="exclude(item.id, $event)" />
                </td>
              </tr>
              <tr v-if="!preview.list.length">
                <td colspan="4">暂无商品</td>
              </tr>
            </tbody>
          </table>
        </div>
        <footer class="preview-pagination">
          <span>共 {{ preview.total }} 条</span>
          <el-pagination
            small
            layout="prev, pager, next"
            :disabled="loading || confirming"
            :current-page="preview.page"
            :page-size="preview.limit"
            :total="preview.total"
            @current-change="loadPreview" />
        </footer>
      </section>
    </main>
    <footer class="actions">
      <p v-if="submissionError" class="submit-validation" role="alert">{{ submissionError }}</p>
      <button class="preview-button" :disabled="loading || confirming || fabricBusy" @click="loadPreview(1)">
        {{ loading ? '加载中…' : '修改内容预览' }}
      </button>
      <button
        class="start"
        :disabled="
          loading ||
          confirming ||
          fabricBusy ||
          !!submissionError ||
          !previewCurrent ||
          !preview ||
          !preview.total ||
          preview.total > 10000
        "
        @click="createBatch">
        {{ confirming ? '正在处理…' : '开始批量修改' }}
      </button>
      <label
        ><el-checkbox v-model="scheduled" :disabled="confirming">定时执行（北京时间）</el-checkbox
        ><el-date-picker
          v-if="scheduled"
          v-model="scheduledAt"
          :disabled="confirming"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择未来时间"
      /></label>
    </footer>
    <product-selector-dialog
      @page-size-change="changeSelectorPageSize"
      :visible="selectorVisible"
      :active-tab="selectorTab"
      :products="selectorProducts"
      :selected-ids="draftSelected.map(productId)"
      :loading="selectorLoading"
      :page="selectorPage"
      :page-size="selectorPageSize"
      :page-sizes="[20, 50, 100, 500, 1000]"
      :total="selectorTab === 'selected' ? draftSelected.length : selectorTotal"
      :total-pages="selectorPages"
      :jump-page="selectorJump"
      :page-fully-selected="selectorRows.length > 0 && selectorRows.every(isSelected)"
      :product-id="productId"
      :product-key="productId"
      :product-title="productTitle"
      :product-image="productImage"
      :product-price="productPrice"
      @close="closeSelector"
      @tab-change="changeSelectorTab"
      @toggle-product="toggleProduct"
      @toggle-page="togglePage"
      @page-change="changeSelectorPage"
      @jump-input="selectorJump = Number($event)"
      @jump="changeSelectorPage(selectorJump)"
      @confirm="confirmSelected"
      ><template #filters
        ><doudian-product-selector-filters
          :value="selectorFilters"
          :shop-id="selectorShopId"
          :shops="shopOptions"
          :categories="categories"
          @shop-change="changeSelectorShop"
          @query="loadSelector(1)" /></template
    ></product-selector-dialog>
  </section>
</template>

<script>
import DoudianBatchShopScope from '@/components/DoudianBatchShopScope'
import DoudianCategoryCascader from '@/components/DoudianCategoryCascader'
import DoudianBatchCommonOptions, { describeCommonOptions } from '@/components/DoudianBatchCommonOptions'
import DoudianBatchPreviewNotice from '@/components/DoudianBatchCommonOptions/PreviewNotice.vue'
import ProductSelectorDialog from '@/components/ProductSelectorDialog/ProductSelectorDialog'
import DoudianProductSelectorFilters from './DoudianProductSelectorFilters.vue'
import CrossFabricRuleFields from './CrossFabricRuleFields.vue'
import {
  previewDoudianCrossAttributeBatch,
  createDoudianCrossAttributeBatch,
  getAuthSuccessShopList,
  getDoudianCategories,
  getProductSelectorProducts
} from '@/api/main/doudianBatchEdit'
import { fields, pairedFields, defaults, buildBatchProductFilter } from './batchModifyFilters'

const newRow = (key) => ({
  key,
  name: '',
  multiple: false,
  text: '',
  number: '',
  unit: '',
  start: '',
  end: '',
  unitPickerVisible: false
})
export default {
  name: 'BatchModifyCrossAttribute',
  components: {
    CrossFabricRuleFields,
    DoudianBatchShopScope,
    DoudianBatchPreviewNotice,
    DoudianCategoryCascader,
    DoudianBatchCommonOptions,
    ProductSelectorDialog,
    DoudianProductSelectorFilters
  },
  data() {
    return {
      tabs: [
        { value: 'range', label: '按范围修改' },
        { value: 'products', label: '选择商品修改' },
        { value: 'product_ids', label: '输入商品ID修改' }
      ],
      mode: 'range',
      filters: defaults(),
      shops: [],
      shopOptions: [],
      categories: [],
      more: false,
      idsText: '',
      selected: [],
      excluded: [],
      groups: [
        { kind: 'ordinary', label: '针对普通属性', enabled: false, rows: [newRow(1)] },
        { kind: 'date', label: '针对时间属性', enabled: false, rows: [newRow(2)] },
        { kind: 'measure', label: '针对带单位属性', enabled: false, rows: [newRow(3)] }
      ],
      nextKey: 4,
      unitGroups: [
        { label: '长度单位', units: ['cm', 'm'] },
        { label: '重量单位', units: ['g', 'kg'] },
        { label: '体积单位', units: ['ml', 'l'] },
        { label: '时间单位', units: ['天', '月', '年'] }
      ],
      skipExisting: false,
      fabricRule: null,
      fabricBusy: false,
      fabricError: '',
      commonOptions: { shelf_action: 0, auto_generate_size_chart: false },
      scheduled: false,
      scheduledAt: '',
      preview: null,
      signature: '',
      previewRequest: 0,
      loading: false,
      confirming: false,
      requestId: '',
      requestSignature: '',
      selectorVisible: false,
      selectorTab: 'all',
      selectorRows: [],
    selectorPageSize: 20,
      selectorPage: 1,
      selectorJump: 1,
      selectorTotal: 0,
      selectorLoading: false,
      selectorRequest: 0,
      selectorShopId: '',
      draftSelected: [],
      selectorFilters: {
        category_id: { level1: [], level2: [], level3: [] },
        platform_product_id: '',
        product_title: '',
        status: '',
        created_at: []
      }
    }
  },
  computed: {
    shownFields() {
      return fields
        .filter(
          (field) =>
            field.key !== 'category_id' &&
            !Object.values(pairedFields).includes(field.key) &&
            (!field.more || this.more) &&
            (this.mode === 'range' || !['platform_product_id', 'created_at', 'status'].includes(field.key))
        )
        .map((field) =>
          pairedFields[field.key]
            ? {
                ...field,
                matchKey: pairedFields[field.key],
                matchOptions: fields.find((item) => item.key === pairedFields[field.key]).options
              }
            : field
        )
    },
    ruleRowCount() {
      return this.groups.reduce((count, group) => count + group.rows.length, 0)
    },
    currentSignature() {
      try {
        return JSON.stringify(this.payload(false))
      } catch (_) {
        return ''
      }
    },
    previewCurrent() {
      return Boolean(this.signature && this.signature === this.currentSignature)
    },
    submissionError() {
      try {
        this.validate(true)
        return ''
      } catch (error) {
        return error.message
      }
    },
    selectorPages() {
      return Math.max(
        1,
        Math.ceil((this.selectorTab === 'selected' ? this.draftSelected.length : this.selectorTotal) / this.selectorPageSize)
      )
    },
    selectorProducts() {
      return this.selectorTab === 'selected'
        ? this.draftSelected.slice((this.selectorPage - 1) * this.selectorPageSize, this.selectorPage * this.selectorPageSize)
        : this.selectorRows
    }
  },
  watch: {
    currentSignature() {
      this.signature = ''
      this.previewRequest++
      this.loading = false
    },
    mode() {
      this.excluded = []
      this.preview = null
    },
    shops() {
      this.excluded = []
      if (this.mode !== 'products') this.selected = []
    }
  },
  mounted() {
    this.loadOptions()
  },
  beforeDestroy() {
    this.previewRequest++
    this.selectorRequest++
  },
  methods: {
    changeSelectorPageSize(size) {
      this.selectorPageSize = Number(size)
      this.selectorPage = 1
      this.loadSelector(1)
    },
    dataOf(response) {
      if (!response || Number(response.code) !== 200) throw new Error(response?.message || '请求失败')
      return response.data
    },
    message(error) {
      return error?.response?.data?.message || error?.message || '请求失败'
    },
    async loadOptions() {
      await Promise.all([
        (async () => {
          try {
            const data = this.dataOf(await getAuthSuccessShopList())
            if (!this._isDestroyed)
              this.shopOptions = (Array.isArray(data) ? data : data.list || data.data || []).filter(
                (shop) => shop.selectable !== false
              )
          } catch (error) {
            if (!this._isDestroyed) this.$message.error(this.message(error))
          }
        })(),
        (async () => {
          try {
            const data = this.dataOf(await getDoudianCategories({ shop_type: 1 }))
            const map = (items) =>
              items.map((item) => ({
                ...item,
                category_id: item.id || item.category_id,
                category_name: item.name || item.category_name,
                children: map(item.children || [])
              }))
            if (!this._isDestroyed) this.categories = map(Array.isArray(data) ? data : data.list || data.data || [])
          } catch (error) {
            if (!this._isDestroyed) this.$message.error(this.message(error))
          }
        })()
      ])
    },
    addRow(group) {
      if (this.ruleRowCount < 20) group.rows.push(newRow(this.nextKey++))
    },
    chooseUnit(row, unit) {
      row.unit = unit
      row.unitPickerVisible = false
    },
    splitValues(value) {
      return [
        ...new Set(
          String(value)
            .split(/[,，]/)
            .map((item) => item.trim())
            .filter(Boolean)
        )
      ]
    },
    payload(create) {
      const productFilter = buildBatchProductFilter(
        this.filters,
        this.shops,
        this.excluded,
        this.mode,
        this.selected.map((item) => String(item.platform_product_id))
      )
      if (this.mode === 'product_ids') {
        delete productFilter.category_id
        delete productFilter.status
        delete productFilter.created_at
        productFilter.platform_product_id = [...new Set(this.idsText.split(/[,，\s]+/).filter(Boolean))]
      }
      const crossRules = this.groups
        .filter((group) => group.enabled)
        .flatMap((group) =>
          group.rows.map((row) =>
            group.kind === 'ordinary'
              ? {
                  name: row.name.trim(),
                  kind: group.kind,
                  values: row.multiple ? this.splitValues(row.text) : [row.text.trim()]
                }
              : group.kind === 'date'
                ? { name: row.name.trim(), kind: group.kind, value: { start: row.start || null, end: row.end || null } }
                : {
                    name: row.name.trim(),
                    kind: group.kind,
                    value: { number: row.number.trim(), unit: row.unit.trim() }
                  }
          )
        )
      const payload = {
        selection_mode: this.mode,
        product_filter: productFilter,
        cross_rules: crossRules,
        skip_existing: this.skipExisting,
        common_options: { ...this.commonOptions },
        ...(this.fabricRule ? { fabric_rule: this.fabricRule } : {})
      }
      if (create && this.scheduled) payload.scheduled_at = this.scheduledAt
      return payload
    },
    validate(create) {
      const payload = this.payload(create),
        rules = payload.cross_rules,
        ids = payload.product_filter.platform_product_id
      if (this.mode !== 'range' && (!ids || !ids.length)) throw new Error('请选择商品或输入商品ID')
      if (ids && (ids.length > 10000 || ids.some((id) => !/^[1-9][0-9]{0,199}$/.test(id))))
        throw new Error('商品ID必须为数字，最多10000个')
      if (this.fabricBusy) throw new Error('请等待图片处理完成')
      if (this.fabricError) throw new Error(this.fabricError)
      if (rules.length > 20 || (create && !rules.length && !this.fabricRule))
        throw new Error('请启用属性或面料修改规则')
      const names = new Set()
      for (const [index, rule] of rules.entries()) {
        const label =
          { ordinary: '普通属性', date: '时间属性', measure: '带单位属性' }[rule.kind] + '第' + (index + 1) + '项'
        if (!rule.name) throw new Error(label + '：请填写属性名称')
        if ([...rule.name].length > 100 || names.has(rule.name))
          throw new Error('启用的属性名称必须为1～100字且不能重复')
        names.add(rule.name)
        if (rule.kind === 'date') {
          if (!rule.value.start || !rule.value.end) throw new Error('请填写开始日期和结束日期')
          if (rule.value.start > rule.value.end) throw new Error('开始日期不能晚于结束日期')
          throw new Error('时间属性暂未开放批量提交，请先取消勾选时间属性')
        }
        if (rule.kind === 'measure') {
          if (!rule.value.number) throw new Error('带单位属性「' + rule.name + '」：请填写数值')
          if (!rule.value.unit) throw new Error('带单位属性「' + rule.name + '」：请选择单位')
        } else if (!rule.values.length || rule.values.some((value) => !value)) {
          throw new Error('普通属性「' + rule.name + '」：请填写目标属性值')
        }
        const values = rule.kind === 'ordinary' ? rule.values : [rule.value.number, rule.value.unit]
        if (
          !values.length ||
          values.length > 100 ||
          values.some((value) => !value || [...value].length > 1000 || ['不修改', '清空属性内容'].includes(value))
        )
          throw new Error('请填写有效目标值，每值最多1000字；不支持清空指令')
        if (rule.kind === 'measure' && !/^-?\d+(?:\.\d+)?$/.test(rule.value.number))
          throw new Error('带单位属性请输入有效数字')
      }
      Object.keys(payload.product_filter)
        .filter((key) => /_(min|max)$/.test(key))
        .forEach((key) => {
          const value = payload.product_filter[key]
          if (!Number.isFinite(value) || value < 0) throw new Error('范围条件必须为有效的非负数')
        })
      if (
        create &&
        this.scheduled &&
        (!/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(this.scheduledAt) ||
          !Number.isFinite(new Date(this.scheduledAt.replace(' ', 'T') + '+08:00').getTime()) ||
          new Date(this.scheduledAt.replace(' ', 'T') + '+08:00') <= new Date())
      )
        throw new Error('请选择北京时间的未来执行时间')
      return payload
    },
    async loadPreview(page = 1) {
      if (this.loading || this.confirming) return
      let payload
      try {
        payload = this.validate(false)
      } catch (error) {
        return this.$message.warning(error.message)
      }
      const signature = JSON.stringify(payload),
        request = ++this.previewRequest
      this.loading = true
      this.signature = ''
      try {
        const data = this.dataOf(await previewDoudianCrossAttributeBatch({ ...payload, page, limit: 20 }))
        if (this._isDestroyed || request !== this.previewRequest || signature !== this.currentSignature) return
        if (
          !Array.isArray(data?.list) ||
          !Number.isInteger(data.total) ||
          !Number.isInteger(data.page) ||
          !Number.isInteger(data.limit) ||
          !data.page_counts
        )
          throw new Error('预览响应格式错误')
        this.preview = data
        this.signature = signature
      } catch (error) {
        if (request === this.previewRequest && !this._isDestroyed) this.$message.error(this.message(error))
      } finally {
        if (request === this.previewRequest) this.loading = false
      }
    },
    resetFilters() {
      this.filters = defaults()
      this.excluded = []
      this.signature = ''
    },
    exclude(id, value) {
      this.excluded = value ? [...new Set([...this.excluded, id])] : this.excluded.filter((item) => item !== id)
    },
    async createBatch() {
      if (this.confirming || this.loading) return
      let payload
      try {
        this.$refs.fabric.validate()
        payload = this.validate(true)
        if (!this.previewCurrent || !this.preview || this.preview.total < 1 || this.preview.total > 10000)
          throw new Error('请先按当前条件预览1～10000件候选商品')
      } catch (error) {
        return this.$message.warning(error.message)
      }
      const frozen = JSON.stringify(payload)
      this.confirming = true
      try {
        await this.$confirm(
          `候选${this.preview.total}件。逐项校验，部分属性可能保留，以执行时核验为准。\n属性：${[...payload.cross_rules.map((rule) => rule.name), ...(payload.fabric_rule ? ['面料材质/水洗标（暂不支持恢复）'] : [])].join('、')}\n${describeCommonOptions(payload.common_options)}${this.scheduled ? '\n北京时间：' + this.scheduledAt : ''}`,
          '确认跨类目属性修改'
        )
        if (this._isDestroyed) return
        if (!this.previewCurrent || frozen !== JSON.stringify(this.payload(true)))
          throw new Error('条件已变化，请重新预览')
        if (this.requestSignature !== frozen) {
          this.requestId = crypto.randomUUID()
          this.requestSignature = frozen
        }
        this.dataOf(await createDoudianCrossAttributeBatch({ ...payload, request_id: this.requestId }))
        if (!this._isDestroyed) {
          this.$message.success('任务已创建，请查看批量修改记录')
          this.$emit('created')
        }
      } catch (error) {
        if (error !== 'cancel' && error !== 'close' && !this._isDestroyed) this.$message.error(this.message(error))
      } finally {
        this.confirming = false
      }
    },
    displayValue(rows) {
      if (rows && !Array.isArray(rows))
        return [
          (rows.composition || []).map((row) => row.name + row.percent + '%').join('、') || '未设置成分',
          (rows.images || []).length ? '图片 ' + rows.images.length + ' 张' : '未设置图片'
        ].join('；')
      return rows == null
        ? '待核验'
        : rows.length
          ? rows.map((row) => (row.name == null ? String(row.value) : row.name)).join('、')
          : '未设置'
    },
    fabricImages(value) {
      return Array.isArray(value?.images)
        ? value.images.filter((url) => typeof url === 'string' && /^https:\/\//.test(url))
        : []
    },
    resultLabel(value) {
      return { ready: '可处理（待实时核验）', skipped: '跳过', unknown: '待核验', failed: '失败' }[value] || value
    },
    typeLabel(type) {
      return (
        {
          select: '单选',
          multi_select: '多选',
          text: '填写',
          input: '填写',
          number: '数值',
          measure: '带单位',
          multi_value_measure: '复合单位',
          fabric: '面料及图片'
        }[type] || (type ? '暂不支持的类型' : '待核验类型')
      )
    },
    async leave() {
      try {
        if (
          this.fabricRule ||
          this.groups.some((group) =>
            group.rows.some((row) => row.name || row.text || row.number || row.unit || row.start || row.end)
          )
        )
          await this.$confirm('返回后将丢失当前填写内容，是否继续？', '离开页面')
        if (!this._isDestroyed) this.$emit('back')
      } catch (_) {
        /* 用户保留当前编辑。 */
      }
    },
    productId(item) {
      return Number(item.distribute_product_id || item.id)
    },
    productTitle(item) {
      return item.product_title || item.title || ''
    },
    productImage(item) {
      return item.main_image || item.img || ''
    },
    productPrice(item) {
      return item.product_price == null ? '价格待定' : '¥' + Number(item.product_price).toFixed(2)
    },
    isSelected(item) {
      return this.draftSelected.some((row) => this.productId(row) === this.productId(item))
    },
    toggleProduct(item) {
      if (
        !this.isSelected(item) &&
        this.draftSelected.length &&
        Number(item.shop_id) !== Number(this.draftSelected[0].shop_id)
      )
        return this.$message.warning('只能选择同一家店铺的商品')
      this.draftSelected = this.isSelected(item)
        ? this.draftSelected.filter((row) => this.productId(row) !== this.productId(item))
        : [...this.draftSelected, item]
    },
    togglePage() {
      const all = this.selectorRows.every(this.isSelected)
      const shop = Number(this.draftSelected[0]?.shop_id || this.selectorRows[0]?.shop_id)
      if (!all && this.selectorRows.some((item) => Number(item.shop_id) !== shop))
        return this.$message.warning('请先筛选同一家店铺')
      this.selectorRows.forEach((item) => {
        if (this.isSelected(item) === all) this.toggleProduct(item)
      })
    },
    async openSelector() {
      this.selectorShopId = this.selected[0]?.shop_id || ''
      this.draftSelected = [...this.selected]
      this.selectorTab = 'all'
      this.selectorVisible = true
      await this.loadSelector(1)
    },
    async closeSelector() {
      try {
        if (
          JSON.stringify(this.draftSelected.map(this.productId)) !== JSON.stringify(this.selected.map(this.productId))
        )
          await this.$confirm('放弃本次选择变更？', '关闭选择商品')
        this.selectorVisible = false
        this.selectorRequest++
      } catch (_) {
        /* 用户继续选择。 */
      }
    },
    changeSelectorTab(tab) {
      this.selectorTab = tab
      this.changeSelectorPage(1)
    },
    changeSelectorPage(page) {
      const next = Math.min(this.selectorPages, Math.max(1, Number(page) || 1))
      if (this.selectorTab === 'all') return this.loadSelector(next)
      this.selectorPage = next
      this.selectorJump = next
    },
    changeSelectorShop(shop) {
      this.selectorShopId = shop
      this.loadSelector(1)
    },
    async confirmSelected() {
      const shop = Number(this.draftSelected[0]?.shop_id)
      if (!shop || this.draftSelected.some((item) => Number(item.shop_id) !== shop))
        return this.$message.warning('请选择同一家店铺的商品')
      this.shops = [shop]
      this.selected = [...this.draftSelected]
      this.selectorVisible = false
      this.selectorRequest++
      this.excluded = []
    },
    async loadSelector(page) {
      const request = ++this.selectorRequest
      this.selectorLoading = true
      try {
        const filters = Object.fromEntries(
          Object.entries(this.selectorFilters).filter(
            ([, value]) => value != null && value !== '' && (!Array.isArray(value) || value.length)
          )
        )
        const data = this.dataOf(
          await getProductSelectorProducts({
            ...filters,
            ...(this.selectorShopId ? { shop_ids: [this.selectorShopId] } : {}),
            page,
            page_size: this.selectorPageSize
          })
        )
        if (this._isDestroyed || request !== this.selectorRequest || !this.selectorVisible) return
        if (!Array.isArray(data.list)) throw new Error('商品响应格式错误')
        this.selectorRows = data.list
        this.selectorTotal = data.pagination?.total ?? data.total
        this.selectorPage = page
        this.selectorJump = page
      } catch (error) {
        if (!this._isDestroyed && request === this.selectorRequest) this.$message.error(this.message(error))
      } finally {
        if (request === this.selectorRequest) this.selectorLoading = false
      }
    }
  }
}
</script>

<style scoped src="./batch-modify.css"></style>
<style scoped>
.fabric-preview-pictures {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 5px;
}
.fabric-preview-pictures .el-image {
  width: 44px;
  height: 44px;
  font-size: 11px;
}
.cross-attribute {
  font-size: 12px;
}
.cross-attribute.has-submit-error > main {
  padding-bottom: 180px;
}
.cross-attribute .actions {
  flex-wrap: wrap;
}
.cross-attribute .submit-validation {
  flex: 1 0 100%;
  margin: 0;
  color: #d84a48;
  font-size: 12px;
  line-height: 18px;
  overflow-wrap: anywhere;
}
.cross-attribute .method-body {
  padding-top: 14px;
}
.cross-attribute .method-body ::v-deep .el-checkbox {
  margin-right: 0;
  white-space: normal;
}
.cross-attribute .method-body ::v-deep .el-checkbox__label {
  font-family: inherit;
  font-size: 12px;
  line-height: 18px;
  color: #1a1a2e;
  white-space: normal;
}
.cross-attribute ::v-deep .el-input__inner {
  font-family: inherit;
}
.cross-attribute .actions ::v-deep .el-checkbox__label {
  font-family: inherit;
  font-size: 12px;
}
.cross-attribute fieldset {
  border: 0;
  margin: 0;
  padding: 0;
  min-width: 0;
}
.rule-group {
  margin: 16px 0;
  border-bottom: 1px solid #eee;
  padding-bottom: 16px;
}
.cross-rule-row.rule-options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 12px;
  align-items: center;
}
.cross-rule-row > * {
  min-width: 0;
}
.cross-rule-row.rule-options > .el-input,
.cross-rule-row.rule-options > .el-select {
  flex: 0 1 auto;
  max-width: calc(100vw - 80px);
}
.cross-rule-row.rule-options > .property-name {
  width: 180px;
}
.cross-rule-row.typed-rule > .property-name {
  width: 144px;
}
.rule-field-label {
  flex: 0 0 auto;
  white-space: nowrap;
  font-size: 12px;
}
.value-label {
  margin-left: 20px;
}
.cross-rule-row.rule-options > .value-count {
  width: 110px;
}
.cross-rule-row.rule-options > .property-value {
  width: 320px;
}
.property-dates {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  overflow: hidden;
}
.cross-rule-row .property-dates > .date-bound {
  width: 134px;
}
.property-dates ::v-deep .el-input__inner {
  height: 26px;
  border: 0;
  border-radius: 0;
}
.date-separator {
  width: 10px;
  color: #999;
  line-height: 26px;
  text-align: center;
  background: #fafafa;
}
.measure-value {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
}
.cross-rule-row .measure-value > .measure-number {
  width: 140px;
}
.cross-rule-row .measure-value > .measure-unit,
.cross-rule-row .measure-unit .unit-input {
  width: 100px;
}
.measure-number ::v-deep .el-input__inner {
  border-right: 0;
  border-radius: 4px 0 0 4px;
}
.unit-input ::v-deep .el-input__inner {
  border-radius: 0 4px 4px 0;
  cursor: pointer;
}
.unit-options {
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 11px;
}
.unit-group + .unit-group {
  margin-top: 10px;
}
.unit-group p {
  margin: 0 0 5px;
  color: #999;
  font-size: 10px;
}
.unit-choices {
  display: grid;
  grid-template-columns: repeat(2, 54px);
  gap: 6px;
}
.unit-choice {
  height: 22px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 3px;
  background: #f5f6f8;
  color: #606266;
  font: inherit;
  cursor: pointer;
}
.unit-choice:hover,
.unit-choice.selected {
  border-color: #b3d8ff;
  background: #ecf5ff;
  color: #409eff;
}
.row-actions {
  display: flex;
  gap: 6px;
}
.row-actions .el-button {
  margin: 0;
  width: 28px;
  height: 28px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 1;
}
.typed-rule .row-actions .el-button {
  width: 22px;
  border: 0;
  background: transparent;
  color: #606266;
  font-size: 20px;
  font-weight: 400;
}
.value-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.cross-preview small {
  display: block;
  color: #777;
  margin-top: 5px;
}
.rule-result + .rule-result {
  margin-top: 12px;
}
.rule-result b {
  font-weight: 500;
}
.cross-attribute .actions > label {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}
@media (max-width: 768px) {
  .cross-rule-row.typed-rule .value-label {
    margin-left: 0;
  }
  .cross-attribute > main {
    padding-bottom: 130px;
  }
  .cross-attribute .actions {
    flex-wrap: wrap;
  }
  .cross-attribute .actions .preview-button {
    display: inline-flex;
    align-items: center;
  }
  .cross-attribute .actions .start {
    margin-right: 0;
  }
}
</style>
